import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreService } from './store.service';
import * as async from 'async';
import { share } from 'rxjs/operators';

@Injectable()
export class PingService {

    progress$: Observable<any>;
    progressObserver: any;
    notify$: Observable<any>;
    notifyObserver: any;

    threads = 10;
    threadCount = 0;

    all: number;
    total: number;
    progressArray: any[];
    requestArray: any[] = [];
    startTime: Date;

    constructor(private storeService: StoreService) {
        this.progress$ = new Observable((observer) => {
            this.progressObserver = observer;
        }).pipe(share());
        this.notify$ = new Observable((observer) => {
            this.notifyObserver = observer;
        }).pipe(share());

    }

    ping(): Observable<any> {

        this.notifyObserver.next('start');

        this.all = 0;
        this.total = 0;
        this.progressArray = [];

        this.startTime = new Date();

        return new Observable((observer) => {
            async.series([
                this.test(this),
                this.test(this),
                this.test(this),
                this.test(this),
                this.test(this),
                this.test(this),
                this.test(this),
                this.test(this),
                this.test(this),
                this.test(this),
            ], (err, results) => {
                this.notifyObserver.next('end');
                observer.complete();
            });
        });

    }

    test(that: any) {
        return (callback: any) => {
            const xhr: XMLHttpRequest = new XMLHttpRequest();
            const url: string = this.storeService.testServer.downloadUrl + 'latency.txt';

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 2) { // HEADERS_RECEIVED // Meaning Ping is done so this should be the interesting part here.
                    const endTime: number = (new Date()).getTime();
                    that.progressObserver.next(endTime - startTime);
                    callback();
                }
            };

            const completeURL = url + '?' + Math.random();

            xhr.open('GET', completeURL, true);
            xhr.send();

            const startTime: number = (new Date()).getTime();
        };
    }

}
